import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedPlural } from 'react-intl';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { statusColours } from '../../constants/ColourConstants';
import SkillIcon from 'material-ui/svg-icons/social/public';

import SkillChip from '../Skill/SkillChip';


const UserSkillSegment = ({skills, userId}) => {

    const iconProps = {
        color: statusColours.default,
    };

    const subtitle = (<span>{skills.length} <FormattedPlural value={skills.length} one='skill' other='skills'/></span>);

    return (
        <Card className="cent-card ">
            <CardHeader
                title={<Link to={`/dashboard/user/${userId}/skills`} >Skills</Link>}
                subtitle={subtitle}
                avatar={<Link to={`/dashboard/user/${userId}/skills`} ><SkillIcon {...iconProps}/></Link>}
            />
            <CardText className="cent-card-chips">
                {skills.map(({skillId, skillName, dateAcquired}) => {
                    return (<SkillChip skill={{id: skillId, name: skillName}} key={skillId} actions={null} userId={userId}/>)})
                }
            </CardText>
        </Card>
    );
};

UserSkillSegment.propTypes = {
    skills: PropTypes.arrayOf(
        PropTypes.shape({
            skillId:      PropTypes.number.isRequired,
            skillName:    PropTypes.string.isRequired,
            dateAcquired: PropTypes.string.isRequired
        })
    )
};

export default UserSkillSegment;
